import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dateFormat from 'dateformat';
import { Link } from 'react-router';
import { Loader } from '../../../../../common/elements';
import { MarkupHelpers as Markup } from '../../../../../../helpers';

class ThreadView extends Component {

    state = {
        pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342',
    };

    componentDidMount() {
        const thread = this.props.thread;
        const id = thread.person_id;
        this.getPicture(id);
    }

    componentWillReceiveProps(nextProps) {
        const id = nextProps.thread.person_id;
        this.getPicture(id);
    }

    getPicture = (personId) => {
        const component = this;
        const url = `https://s3.intouchnetworks.com/getImage.php?id=${personId}`;
        fetch(url)
            .then(response => {
                if (response.ok) {
                    return response.text();
                }
            })
            .then(res => {
                if (res !== undefined) {
                    component.setState({ pictureUrl: res });
                } else {
                    component.setState({ pictureUrl: 'https://vignette2.wikia.nocookie.net/naginoasukara/images/8/86/Placeholder_person.png/revision/latest?cb=20130924151342' })
                }

            })
    }

    render() {
        const src = this.state.pictureUrl;
        const { thread, quoteReplyHandler } = this.props;
        const convertedTitle = Markup.escapeHtmlHelper(thread.title),
            convertedDescription = Markup.escapeHtmlHelper(thread.description);

        if (!this.props) {
            return <Loader />;
        }

        return (
            <div className="col-12 forum-card">
                <div className="inner-card">
                    <div className="col-12 col-lg-10 forum-info">
                        <h4 className="col-12 heading-three">{convertedTitle}</h4>
                        <p className="body-copy" dangerouslySetInnerHTML={{ __html: `${convertedDescription}` }}></p>
                        <div className="discussion-info-box">
                            <h4 className="body-copy">Posted: {dateFormat(thread.verified_at, 'dd/mm/yyyy')}</h4>
                            <h4 className="body-copy">Replies: {thread.replies}</h4>
                            {/* <button onClick={quoteReplyHandler} className="theme-button">Reply</button>*/}
                        </div>
                    </div>
                    <Link className="col-12 col-md-2 col-lg-2 user-profile-box" to={`/members/${this.props.thread.person_id}`}>
                        <img src={src} className="img-circle" alt="Member Img" height="150" />
                        <p className="user-name clickable">{thread.person.first_name} {thread.person.last_name}</p>
                    </Link>
                </div>
            </div>
        );
    };
}

ThreadView.propTypes = {
    thread: PropTypes.object
}

export default ThreadView;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/ThreadView.js